import { ReactNode } from 'react'
import { getLockedTransactionDescription } from '../copyConstants'
import { Tooltip } from '@/ui'

export const CellContent = ({
  locked,
  children,
}: {
  locked: boolean
  children: ReactNode
}) => {
  if (!locked) return children

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <div className="pointer-events-auto">{children}</div>
      </Tooltip.Trigger>
      <Tooltip.Content side="top">
        {getLockedTransactionDescription().transactionRowLockIconTooltip}
      </Tooltip.Content>
    </Tooltip>
  )
}
